import React from "react";
import PublicV2Layout from "../layout/PublicV2Layout";
import CustomerQuotePage from "../../pages/CustomerQuotePage/CustomerQuotePage";
import "./customerDocV2.css";

const noop = () => {};

/**
 * v2 chrome around the existing customer Quote display (reused as-is — single
 * source of truth for the quote/accept flow). Inner nav setters are no-ops; the
 * v2 layout owns chrome suppression/restore. Reaches data via the :quoteId route
 * param + ?token, exactly like prod.
 */
const CustomerQuotePageV2 = (navProps) => (
  <PublicV2Layout {...navProps}>
    <div className="bdrv2-doc bdrv2-section">
      <div className="bdrv2-container bdrv2-customer-doc">
        <CustomerQuotePage
          displayNav={noop}
          changeStickyTab={noop}
          changeFooter={noop}
        />
      </div>
    </div>
  </PublicV2Layout>
);

export default CustomerQuotePageV2;
